import { media } from './styledMedia';
import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  html{
      box-sizing: border-box;
      font-size: 62.5%;
      line-height: 1.42857;
      background: #fbfbfb;
      font-family: "Rubik", "Helvetica", "Arial", sans-serif;
  }
  body{
    font-family: "Rubik", "Helvetica", "Arial", sans-serif;
  }
  a{
    text-decoration: none;
    &:hover{
      text-decoration: underline;
    }
  }
  a, a:visited a:active {
    color: #0061ff;
  }

  a:hover {
    color: #004dc9;
  }

  input:required:invalid {
    outline: none;
  }
  input:invalid {
    outline: none;
    box-shadow:none;
  }
  select:invalid {
    outline: none;
    box-shadow:none;
  }
  ${media.xs`
  &&{
      html, body{
        background-color: #ffffff;
      }
    }
  `}
`;
